<template>
  <div class="wrapper">
    <modal :show.sync="modals.modal1" modal-classes="modal-dialog-centered">
      <h6 slot="header" class="modal-title">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h4 class="heading mt-4">
          Votre numéro de dossier ou votre mot de passe est incorrect !
        </h4>
        <br />
        <h5>
          Votre mot de passe correspond aux <b>5 dernières lettres</b> de votre
          nom (hors: espace,tiret,tiret bas).
        </h5>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal1 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal2" modal-classes="modal-dialog-centered">
      <h6 slot="header" class="modal-title">
        Déconnexion
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h4 class="heading mt-4">
          Votre session a expiré.
        </h4>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal2 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.modal3"
      modal-classes="modal-dialog-centered modal-xl"
    >
      <h6 slot="header" class="modal-title">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h4 class="heading mt-4">
          Une erreur grave c'est produite ! Veuillez contacter le cabinet au
          05.61.83.29.13 ou réessayer.
        </h4>
        <br />
        <h5>Code Erreur : REQUEST_ERROR</h5>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal3 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.modal4"
      modal-classes="modal-dialog-centered modal-xl"
    >
      <h6 slot="header" class="modal-title">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h4 class="heading mt-4">
          Une erreur grave c'est produite ! Veuillez contacter le cabinet au
          05.61.83.29.13 ou réessayer.
        </h4>
        <br />
        <h5>Code Erreur : NO_DATA_RECEIVE</h5>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal4 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.modal5"
      modal-classes="modal-dialog-centered modal-xl"
    >
      <h6 slot="header" class="modal-title">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h4 class="heading mt-4">
          Une erreur grave c'est produite ! Veuillez contacter le cabinet au
          05.61.83.29.13 ou réessayer.
        </h4>
        <br />
        <h5>Code Erreur : USERNAME_SIZE</h5>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal5 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal6" modal-classes="modal-dialog-centered">
      <h6 slot="header" class="modal-title">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h4 class="heading mt-4">
          Une erreur grave c'est produite ! Veuillez contacter le cabinet au
          05.61.83.29.13 ou réessayer.
        </h4>
        <br />
        <h5>Code Erreur : {{ error_access }}</h5>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal6 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal7" modal-classes="modal-dialog-centered">
      <h6 slot="header" class="modal-title">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h4 class="heading mt-4">
          Une erreur grave c'est produite ! Veuillez contacter le cabinet au
          05.61.83.29.13 ou réessayer.
        </h4>
        <br />
        <h5>Code Erreur : ACCESS DENIED</h5>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal7 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <div class="section-shaped my-0 skew-separator skew-mini">
      <div class="page-header page-header-small header-filter">
        <div
          class="page-header-image"
          style="background-image: url('img/brand/anhod.png');"
        ></div>
        <div id="img">
          <img src="img/brand/help.jpg" />
          <div class="box arrow-top">
            Besoin d'aide ?<br />
            <b id="number">05.61.83.29.13</b> <br />
            Du <b>lundi</b> au <b>vendredi</b><br />
            de <b>9h</b> à <b>12h</b> et <b>14h</b> à <b>18h</b>
          </div>
        </div>
        <div class="container">
          <div class="header-body text-center mb-7">
            <div class="row justify-content-center">
              <div class="col-xl-5 col-lg-6 col-md-8 px-5">
                <h1 class="text-white">Bienvenue!</h1>
                <p class="text-lead text-white">
                  Vous pouvez utiliser ce formulaire pour vous connecter à votre
                  espace de recouvrement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="upper">
      <div class="container">
        <div class="col-lg-5 col-md-8 mx-auto">
          <div class="card bg-secondary shadow border-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Vos identifiants de connexion</small>
              </div>
              <form role="form">
                <div class="form-group mb-3">
                  <base-input
                    alternative
                    placeholder="Numéro de dossier"
                    addonLeftIcon="ni ni-circle-08"
                    v-model="login"
                    @keydown.enter="Connexion"
                  ></base-input>
                </div>
                <div class="form-group">
                  <base-input
                    alternative
                    placeholder="Mot de Passe"
                    addonLeftIcon="ni ni-lock-circle-open"
                    type="password"
                    id="mdp"
                    v-model="mdp"
                    @keydown.enter="Connexion"
                  ></base-input>
                  <!--<base-checkbox
                    class="mb-3"
                    v-model="checkboxes"
                    @change="voirMdp(!checkboxes)"
                  >
                    Voir le mot de passe
                  </base-checkbox>-->
                  <a style="font-size: 1.25em;">
                    * Votre mot de passe correspond aux
                    <b>5 dernières lettres</b> de votre nom (hors:
                    espace,tiret,tiret bas).
                  </a>
                </div>
                <div class="text-center">
                  <base-button type="anhod2" class="my-4" @click="Connexion"
                    >Connexion</base-button
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Modal from "@/components/Modal";
import axios from "axios";
import { HTTP_REQUEST } from "../constants/constantes";
import router from "@/router";
export default {
  bodyClass: "login-page",
  components: {
    Modal
  },
  data() {
    return {
      login: "",
      mdp: "",
      error_access: "",

      i: 0,

      type: this.$route.params.type,
      id: this.$route.params.id,
      pswrd: this.$route.params.pswrd,

      modals: {
        modal1: false,
        modal2: false,
        modal3: false,
        modal4: false,
        modal5: false,
        modal6: false,
        modal7: false
      },

      checkboxes: false
    };
  },
  created: function() {
    this.getStatut();
    this.Verification();
    this.Maintenance();
  },
  methods: {
    Maintenance: function() {
      let dateDebut = "01/05/2021";
      let dateFin = "03/05/2021";
      let date = new Date();
      let d1 = dateDebut.split("/");
      let d2 = dateFin.split("/");
      let debut = new Date(d1[2], parseInt(d1[1] - 1), d1[0]);
      let fin = new Date(d2[2], parseInt(d2[1] - 1), d2[0]);
      let result = date > debut && date < fin;
      if (result) {
        this.$router.push("/off");
      }
    },
    // Récupération du statut du login
    getStatut: function() {
      if (this.type == 1) {
        this.modals.modal2 = true;
      }
      if (this.id != 0 && this.pswrd != 0) {
        this.login = this.id;
        this.mdp = this.pswrd;
        this.Connexion();
      }
    },
    // Vérification du token existant
    Verification: function() {
      if (this.$store.state.tokens != "") {
        const self = this;
        let getDataApi = async function() {
          var postAction = "action=Verif_CreateToken";
          var postToken = "&token=" + self.$store.state.tokens;
          var postDossier = "&dossier=0";
          var postMotdepasse = "&motdepasse=0";
          var postData = postAction + postToken + postDossier + postMotdepasse;
          const retourRequete = await axios.post(HTTP_REQUEST, postData);
          return retourRequete;
        };
        getDataApi().then(function(retourApi) {
          if (retourApi.data) {
            if (retourApi.data == "INVALID PARAMS") {
              self.modals.modal1 = true;
            } else if (retourApi.data == "ERROR") {
              self.modals.modal3 = true;
            } else {
              router.push("/recouvrement");
            }
          } else {
            self.modals.modal4 = true;
          }
        });
      }
    },
    // Vérification des identifiants et création du token
    Connexion: function() {
      if (this.login == "") {
        this.modals.modal1 = true;
      } else if (this.mdp == "") {
        this.modals.modal1 = true;
      } else {
        const self = this;
        let getDataApi = async function() {
          var postAction = "action=Verif_CreateToken";
          var postToken = "&token=";
          var postDossier = "&dossier=" + self.login;
          var postMotdepasse = "&motdepasse=" + JSON.stringify(self.mdp);
          var postData = postAction + postToken + postDossier + postMotdepasse;
          const retourRequete = await axios.post(HTTP_REQUEST, postData);
          return retourRequete;
        };
        getDataApi().then(function(retourApi) {
          if (retourApi.data) {
            if (retourApi.data == "INVALID PARAMS") {
              self.modals.modal1 = true;
            } else if (retourApi.data == "ERROR") {
              self.modals.modal3 = true;
            } else if (retourApi.data == "ERROR_SIZE") {
              self.modals.modal5 = true;
            } else if (retourApi.data == "ACCESS_DENIED") {
              self.modals.modal7 = true;
            } else if (
              retourApi.data == "ERROR_QUERY_1" ||
              retourApi.data == "ERROR_QUERY_2"
            ) {
              self.error_access = retourApi.data;
              self.modals.modal6 = true;
            } else {
              self.$store.commit("addToken", retourApi.data);
              router.push("/recouvrement");
            }
          } else {
            self.modals.modal4 = true;
          }
        });
      }
    }
  }
};
</script>
<style scoped>
@media screen and (min-width: 900px) {
  #img {
    position: relative;
    top: -10em;
  }
  #number {
    font-size: x-large;
  }
  #img img {
    position: absolute;
    border-radius: 50%;
    top: -9em;
    left: 1em;
    width: 125px;
  }
  .box {
    width: 215px;
    height: 130px;
    background-color: #b2aa68;
    color: white;
    padding: 0.75em;
    position: absolute;
    margin: 30px;
    left: 1em;
    float: left;
    border-radius: 7.5%;
  }
  .box.arrow-top {
    margin-top: 1em;
  }
  .box.arrow-top:after {
    content: " ";
    position: absolute;
    left: 10px;
    top: -15px;
    border-top: none;
    border-right: 20px solid transparent;
    border-left: 20px solid transparent;
    border-bottom: 20px solid #b2aa68;
  }
}
@media screen and (max-width: 899px) {
  #img {
    position: relative;
    top: -10em;
  }
  #img img {
    position: absolute;
    border-radius: 50%;
    top: -3em;
    left: 1em;
    width: 75px;
  }
  #number {
    font-size: medium;
  }
  .box {
    width: 200px;
    height: 100px;
    background-color: #b2aa68;
    color: white;
    padding: 0.75em;
    position: absolute;
    margin: 30px;
    left: 5em;
    top: -4em;
    float: left;
    border-radius: 7.5%;
  }
  .box.arrow-top {
    margin-top: 1em;
    font-size: small;
  }
  .box.arrow-top:after {
    content: " ";
    position: absolute;
    left: -15px;
    top: 15px;
    border-top: none;
    border-right: 15px solid #b2aa68;
    border-top: 15px solid transparent;
    border-left: none;
    border-bottom: 20px solid transparent;
  }
}
</style>
